<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

      <sidenav-router-link icon="ion ion-ios-contact" to="/" :exact="true">Home</sidenav-router-link>

      <sidenav-menu icon="ion ion-md-book" :active="isMenuActive('/program')" :open="isMenuOpen('/program')">
        <template slot="link-text">Catalog</template>
        <sidenav-router-link to="/program/books" :exact="true">Books</sidenav-router-link>
        <sidenav-router-link to="/program/categories" :exact="true">Categories</sidenav-router-link>
        <sidenav-router-link to="/program/koop" :exact="true">KOOP</sidenav-router-link>
        <sidenav-router-link to="/program/formats" :exact="true">Formats</sidenav-router-link>
        <sidenav-router-link to="/program/bindings" :exact="true">Bindings</sidenav-router-link>
        <sidenav-router-link to="/program/coverversions" :exact="true">Cover Versions</sidenav-router-link>
        <sidenav-router-link to="/program/languageversions" :exact="true">Language Versions</sidenav-router-link>
        <sidenav-router-link to="/program/paper" :exact="true">Paper</sidenav-router-link>
        <sidenav-router-link to="/program/stampings" :exact="true">Stampings</sidenav-router-link>
        <sidenav-router-link to="/program/materials" :exact="true">Materials</sidenav-router-link>
        <sidenav-router-link to="/program/laminations" :exact="true">Laminations</sidenav-router-link>
        <sidenav-router-link to="/program/colors" :exact="true">Colors</sidenav-router-link>
      </sidenav-menu>

      <sidenav-router-link icon="ion ion-ios-apps" to="/origination" :exact="true">Origination</sidenav-router-link>

      <sidenav-menu icon="ion ion-logo-euro" :active="isMenuActive('/market')" :open="isMenuOpen('/market')">
        <template slot="link-text">Market</template>

        <sidenav-menu icon="ion ion-md-people" :active="isMenuActive('/market/customers')" :open="isMenuOpen('/market/customers')">
          <template slot="link-text">Customer</template>
          <sidenav-router-link to="/market/customers/addresses">Addresses</sidenav-router-link>
          <sidenav-router-link to="/market/customers/addresscategories">Address Categories</sidenav-router-link>
          <sidenav-router-link to="/market/customers/rights">Rights</sidenav-router-link>
        </sidenav-menu>

         <sidenav-menu icon="ion ion-md-list" :active="isMenuActive('/market/orders')" :open="isMenuOpen('/market/orders')">
          <template slot="link-text">Orders</template>
          <sidenav-router-link to="/market/orders/offer">Offer</sidenav-router-link>
          <sidenav-router-link to="/market/orders/samples">Sample</sidenav-router-link>
          <sidenav-router-link to="/market/quasi">Quasi</sidenav-router-link>
          <sidenav-router-link to="/market/orders/po">Purchase Order</sidenav-router-link>
          <sidenav-router-link to="/market/orders/invoices">Invoice</sidenav-router-link>
          <sidenav-router-link to="/market/orders/creditnotes">Creditnotes</sidenav-router-link>
          <sidenav-router-link to="/market/orders/ao">Armed Orders</sidenav-router-link>
          <sidenav-router-link to="/market/orders/payments">Payments</sidenav-router-link>
          <sidenav-router-link to="/market/orders/stats">Stats / Exports</sidenav-router-link>
        </sidenav-menu>

        <sidenav-menu icon="ion ion-md-swap" :active="isMenuActive('/market/stock')" :open="isMenuOpen('/market/stock')">
          <template slot="link-text">Stock</template>
          <sidenav-router-link to="/market/stock/printnotes">Print Notes</sidenav-router-link>
          <sidenav-router-link to="/market/stock/stocknotes">Stock Notes</sidenav-router-link>
          <sidenav-router-link to="/market/stock/stockinvoices">Stock Invoices</sidenav-router-link>
          <sidenav-router-link to="/market/stock/stockvalues">Stock Value</sidenav-router-link>
          <sidenav-router-link to="/market/stock/export">Export</sidenav-router-link>
        </sidenav-menu>

        <sidenav-menu icon="ion ion-ios-trending-up" :active="isMenuActive('/market/accounting')" :open="isMenuOpen('/market/accounting')">
          <template slot="link-text">Accounting</template>
          <sidenav-router-link to="/market/accounting/incominginvoices">Incoming Invoices</sidenav-router-link>
          <sidenav-router-link to="/market/accounting/accounts">Accounts</sidenav-router-link>
          <sidenav-router-link to="/market/accounting/paymentmethods">Payment Methods</sidenav-router-link>
        </sidenav-menu>

      </sidenav-menu>

      <sidenav-menu icon="ion ion-md-apps" :active="isMenuActive('/misc')" :open="isMenuOpen('/misc')">
          <template slot="link-text">Misc</template>
          <sidenav-router-link to="/misc/currencies" :exact="true">Currencies</sidenav-router-link>
          <sidenav-router-link to="/misc/exchange" :exact="true">Exchange</sidenav-router-link>
          <sidenav-router-link to="/misc/ports" :exact="true">Ports</sidenav-router-link>
          <sidenav-router-link to="/misc/retail" :exact="true">Retail</sidenav-router-link>
        </sidenav-menu>

    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'

export default {
  name: 'app-layout-sidenav',
  components: {
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }
}
</script>
